export type VpnPlusShareCodeDictionary = {
    eyebrow: string;
    title: string;
    description: string;
    codeLabel: string;
    invalidCodeFallback: string;
    loginTitle: string;
    loginCopy: string;
    loginAction: string;
    readyTitle: string;
    readyCopy: string;
    redeemAction: string;
    redeemingAction: string;
    redeemingTitle: string;
    redeemingCopy: string;
    redeemedTitle: string;
    redeemedCopy: string;
    expiredTitle: string;
    expiredCopy: string;
    usedTitle: string;
    usedCopy: string;
    cancelledTitle: string;
    cancelledCopy: string;
    selfRedeemTitle: string;
    selfRedeemCopy: string;
    insufficientBalanceTitle: string;
    insufficientBalanceCopy: string;
    rateLimitedTitle: string;
    rateLimitedCopy: string;
    invalidTitle: string;
    invalidCopy: string;
    featureOffTitle: string;
    featureOffCopy: string;
    unavailableTitle: string;
    unavailableCopy: string;
    copyLink: string;
    copyLinkSuccess: string;
    copyLinkFailed: string;
};

export const VPN_PLUS_SHARE_CODE_RU: VpnPlusShareCodeDictionary = {
    eyebrow: 'VPN+',
    title: 'Получить общий VPN+ трафик',
    description: 'Войдите в существующий аккаунт Chattenger, чтобы перенести удержанный VPN+ лимит на свой баланс.',
    codeLabel: 'ID кода',
    invalidCodeFallback: 'Некорректный код',
    loginTitle: 'Войдите, чтобы продолжить',
    loginCopy: 'Войдите в существующий аккаунт, чтобы получить этот VPN+ лимит.',
    loginAction: 'Войти',
    readyTitle: 'Готово к получению',
    readyCopy: 'Код можно использовать один раз. Chattenger проверит его перед изменением вашего VPN+ баланса.',
    redeemAction: 'Получить',
    redeemingAction: 'Проверяем…',
    redeemingTitle: 'Проверяем код',
    redeemingCopy: 'Chattenger проверяет этот VPN+ код.',
    redeemedTitle: 'VPN+ трафик добавлен',
    redeemedCopy: 'Общий VPN+ лимит добавлен к вашему аккаунту.',
    expiredTitle: 'Срок кода истёк',
    expiredCopy: 'Этот код больше не активен. Попросите отправителя создать новый.',
    usedTitle: 'Код уже использован',
    usedCopy: 'Этот код уже был получен и не может использоваться повторно.',
    cancelledTitle: 'Код отменён',
    cancelledCopy: 'Отправитель отменил этот код до получения.',
    selfRedeemTitle: 'Выберите другой аккаунт',
    selfRedeemCopy: 'Отправитель не может получить собственный VPN+ код.',
    insufficientBalanceTitle: 'Лимит недоступен',
    insufficientBalanceCopy: 'Этот код больше не может передать удержанный VPN+ лимит.',
    rateLimitedTitle: 'Пожалуйста, подождите',
    rateLimitedCopy: 'Повторите попытку с этим кодом после короткой паузы.',
    invalidTitle: 'Код недоступен',
    invalidCopy: 'Этот код некорректен или повреждён.',
    featureOffTitle: 'VPN+ обмен недоступен',
    featureOffCopy: 'Получение VPN+ кодов сейчас не включено для этого аккаунта.',
    unavailableTitle: 'Не удалось получить',
    unavailableCopy: 'Chattenger не смог получить этот код сейчас. Попробуйте позже.',
    copyLink: 'Скопировать ссылку',
    copyLinkSuccess: 'VPN+ ссылка скопирована.',
    copyLinkFailed: 'Не удалось скопировать ссылку.',
};
